/** VOID_TYPE_USAGE fallback - empty payload per graft model */
export const VOID_TYPE_USAGE_FALLBACK = { payload: [] as readonly unknown[] }
